import React, { useEffect, useState } from "react";
import "../css/ViewEnquiry.css";
import BackgroundImage from "./BackgroundImage";
import icDownloadToExcel from "../img/ic_download_to_excel.png";
import { useLocation } from "react-router-dom";
import axios from "axios";
import useDownloadToExcel from "./useDownloadToExcelViewDraft";


function ViewDraft() {

  const [status, downloadToExcel] = useDownloadToExcel();

  const location = useLocation();
  const dataFromEnquiry = location.state;
  const [initialViewValues, setInitialViewValues] = useState({
    reference: "",
    remarks: "",
    dateTime: "",
    draftNo: "",
    table_row_values: [],
  });

  console.log("data from enquiry ", dataFromEnquiry);

  const callCustomDownloadHook = () => {

    if (initialViewValues.table_row_values) {

      console.log(" initialViewValues.table_row_values ", initialViewValues.table_row_values)

      if (initialViewValues.table_row_values[0].code != "") {
        downloadToExcel(initialViewValues, initialViewValues.table_row_values);
      } else {
        alert("No data to download")
      }


    } else {
      alert("No data to download")
    }

  };

  useEffect(() => {
    const apiUrl = `https://api-crm.premierauto.ae/api/EnquiryDraft/${dataFromEnquiry.enquiryNumber}/${dataFromEnquiry.companyCodeForView}`;
    axios
      .get(apiUrl)
      .then((res) => {
        console.log("ViewEnquiry API response success ", res.data);
        setInitialViewValues({
          ...initialViewValues,
          reference: res.data[0].ord_H_ref,
          remarks: res.data[0].ord_H_remarks,
          dateTime: res.data[0].ord_H_datetime,
          draftNo: res.data[0].ord_H_ID,
          table_row_values: res.data,
        });
      })
      .catch((e) => {
        console.log("ViewEnquiry API response error ", e);
      });
  }, []);



  return (
    <div>
      <div className="ViewEnquiry-main-container">
        <h5>View Draft</h5>

        <div className="d-flex">
          <div className="ViewEnquiry-left-container">
            <div >
              <label>Draft No.</label>
              <span className="ViewEnquiry-label-value-colon">:</span>
              <span className="ViewEnquiry-label-value">
                {initialViewValues.draftNo}
              </span>
            </div>

          </div>

          <div className="ViewEnquiry-right-container">
            <div >
              <label>Date &amp; Time</label>
              <span className="ViewEnquiry-label-value-colon">:</span>
              <span className="ViewEnquiry-label-value">
                {initialViewValues.dateTime}
              </span>
            </div>
          </div>
        </div>

        <div className="d-flex">
          <div className="ViewEnquiry-left-container">
            <label>Reference</label>
            <span className="ViewEnquiry-label-value-colon">:</span>
            <span className="ViewEnquiry-label-value">
              {initialViewValues.reference}
            </span>
          </div>
          <div className="ViewEnquiry-left-container">
            <label>Your Remarks</label>
            <span className="ViewEnquiry-label-value-colon">:</span>
            <span className="ViewEnquiry-label-value">
              {initialViewValues.remarks}
            </span>
          </div>
        </div>

        <div className="ViewEnquiry-excel-button-container">
          <button className="ViewEnquiry-excel-button" onClick={callCustomDownloadHook}>
            <img src={icDownloadToExcel} alt="placeholder" />{" "}
            <span>Download To Excel</span>
          </button>
        </div>


        

        <table className="ViewEnquiry-table">
          <thead>
            <tr>
              <th>Sl.No.</th>
              <th>Part Number</th>
              <th>Description</th>
              <th>Qty Req</th>
            </tr>
          </thead>
          <tbody>
            {initialViewValues.table_row_values.map((item, index) => {
              return (
                <tr key={index}>
                  {console.log(" enquiry item ", item)}
                  <td>{index + 1}</td>
                  <td>{item.code}</td>
                  <td>{item.description}</td>
                  <td>{item.req_ty}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <BackgroundImage />
      </div>




    </div>
  );
}

export default ViewDraft;
